import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const SignupModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SignupModalContainer" */
      './SignupModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
